/* ============================================================
   APEX MOTO — global.js
   Vanilla JS, no dependencies. Progressive enhancement.
   ============================================================ */
(function () {
  "use strict";
  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ---------- Mobile nav drawer ---------- */
  function initDrawer() {
    const drawer = $("[data-drawer]");
    const scrim  = $("[data-scrim]");
    if (!drawer) return;
    const open  = () => { drawer.classList.add("is-open"); scrim.classList.add("is-open"); document.body.style.overflow = "hidden"; };
    const close = () => { drawer.classList.remove("is-open"); scrim.classList.remove("is-open"); document.body.style.overflow = ""; };
    $$("[data-drawer-open]").forEach(b => b.addEventListener("click", open));
    $$("[data-drawer-close]").forEach(b => b.addEventListener("click", close));
    scrim && scrim.addEventListener("click", close);
    document.addEventListener("keydown", e => e.key === "Escape" && close());
  }

  /* ---------- Hero slider ---------- */
  function initHero() {
    $$("[data-hero]").forEach(hero => {
      const track = $(".hero__track", hero);
      const slides = $$(".hero__slide", hero);
      const dots  = $$(".hero__dot", hero);
      if (slides.length < 2) return;
      let i = 0;
      const speed = parseInt(hero.dataset.speed || "6000", 10);
      const go = n => {
        i = (n + slides.length) % slides.length;
        track.style.transform = `translateX(-${i * 100}%)`;
        dots.forEach((d, k) => d.setAttribute("aria-current", k === i));
      };
      track.style.transition = "transform .8s cubic-bezier(.22,1,.36,1)";
      dots.forEach((d, k) => d.addEventListener("click", () => go(k)));
      let timer = setInterval(() => go(i + 1), speed);
      hero.addEventListener("mouseenter", () => clearInterval(timer));
      hero.addEventListener("mouseleave", () => { timer = setInterval(() => go(i + 1), speed); });
      go(0);
    });
  }

  /* ---------- Horizontal scroller nav (products / categories / reviews) ---------- */
  function initScrollers() {
    $$("[data-scroller-wrap]").forEach(wrap => {
      const track = $("[data-scroller]", wrap);
      const prev  = $("[data-scroll-prev]", wrap);
      const next  = $("[data-scroll-next]", wrap);
      if (!track) return;
      const step = () => Math.max(track.clientWidth * 0.8, 300);
      prev && prev.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
      next && next.addEventListener("click", () => track.scrollBy({ left:  step(), behavior: "smooth" }));
      const update = () => {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      };
      track.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);
      update();
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq() {
    $$("[data-faq-item]").forEach(item => {
      const btn    = $(".faq__q", item);
      const panel  = $(".faq__a", item);
      const inner  = $(".faq__a-inner", item);
      if (!btn || !panel) return;
      btn.addEventListener("click", () => {
        const open = item.getAttribute("aria-expanded") === "true";
        // close siblings in same group for a clean single-open UI
        if (!open) {
          $$("[data-faq-item]", item.closest("[data-faq-group]") || document).forEach(sib => {
            sib.setAttribute("aria-expanded", "false");
            const p = $(".faq__a", sib); if (p) p.style.height = "0px";
          });
        }
        item.setAttribute("aria-expanded", String(!open));
        panel.style.height = open ? "0px" : inner.scrollHeight + "px";
      });
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    const els = $$("[data-reveal]");
    if (!els.length || !("IntersectionObserver" in window)) { els.forEach(e => e.classList.add("is-in")); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    els.forEach(e => io.observe(e));
  }

  /* ---------- Product gallery + zoom ---------- */
  function initProduct() {
    const gallery = $("[data-gallery]");
    if (gallery) {
      const stage = $(".product__stage img", gallery);
      const stageWrap = $(".product__stage", gallery);
      $$("[data-thumb]", gallery).forEach(thumb => {
        thumb.addEventListener("click", () => {
          $$("[data-thumb]", gallery).forEach(t => t.classList.remove("is-active"));
          thumb.classList.add("is-active");
          stage.src = thumb.dataset.full || $("img", thumb).src;
        });
      });
      // magnify / zoom on desktop
      if (stageWrap && window.matchMedia("(min-width: 901px)").matches) {
        stageWrap.addEventListener("mousemove", e => {
          const r = stageWrap.getBoundingClientRect();
          const x = ((e.clientX - r.left) / r.width) * 100;
          const y = ((e.clientY - r.top) / r.height) * 100;
          stage.style.transformOrigin = `${x}% ${y}%`;
        });
        stageWrap.addEventListener("mouseenter", () => stageWrap.classList.add("is-zoomed"));
        stageWrap.addEventListener("mouseleave", () => stageWrap.classList.remove("is-zoomed"));
      }
    }

    // sticky add-to-cart reveal
    const bar   = $("[data-sticky-atc]");
    const form  = $("[data-product-form]");
    if (bar && form) {
      const io = new IntersectionObserver(([e]) => {
        bar.classList.toggle("is-visible", !e.isIntersecting);
      }, { rootMargin: "-120px 0px 0px 0px" });
      io.observe(form);
    }
  }

  /* ---------- Collection facets drawer (mobile) ---------- */
  function initFacets() {
    const panel = $("[data-facets]");
    if (!panel) return;
    $$("[data-facets-toggle]").forEach(b => b.addEventListener("click", () => panel.classList.toggle("is-open")));
    $("[data-facets-close]", panel)?.addEventListener("click", () => panel.classList.remove("is-open"));
  }

  /* ---------- Header state on scroll ---------- */
  function initHeader() {
    const h = $("[data-header]");
    if (!h) return;
    const onScroll = () => h.classList.toggle("is-scrolled", window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  // Tabbed sections (What's New)
  function initTabs() {
    document.querySelectorAll("[data-tabs]").forEach((root) => {
      const tabs = Array.from(root.querySelectorAll("[data-tab]"));
      const panels = Array.from(root.querySelectorAll("[data-panel]"));
      if (!tabs.length) return;
      tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
          const id = tab.getAttribute("data-tab");
          tabs.forEach((t) => t.classList.toggle("is-active", t === tab));
          panels.forEach((p) => p.classList.toggle("is-active", p.getAttribute("data-panel") === id));
        });
      });
    });
  }

  function initWishlist() {
    $$("[data-wishlist]").forEach(b => b.addEventListener("click", (e) => {
      e.preventDefault();
      b.classList.toggle("is-active");
    }));
  }

  document.addEventListener("DOMContentLoaded", () => {
    initDrawer(); initHero(); initScrollers(); initFaq();
    initReveal(); initProduct(); initFacets(); initHeader(); initTabs();
    initWishlist();
  });
})();
